import script from "./SalleAMangerView.vue?vue&type=script&setup=true&lang=js"
export * from "./SalleAMangerView.vue?vue&type=script&setup=true&lang=js"

import "./SalleAMangerView.vue?vue&type=style&index=0&id=f7e3ba68&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f7e3ba68"]])

export default __exports__